import apiEndpoints from '../../constants/ApiEndpoints';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import Checkbox from '@mui/material/Checkbox';
import bidSchema from '../../validations/Bid'
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import Link from '@mui/material/Link';


function SellerFeedbackForm() {

  const navigate = useNavigate();

  const initialValues = {
    'user_name': '',
    'description': '',
    'file': '',
    'mob_number': '',
    'email': '',
  }
  const dispatch = useDispatch();

  const onSubmit = values => {
    submitSellerFeedback(values);
  }

  const formik = useFormik({
    initialValues,
    onSubmit,
    // validate,
    validationSchema: bidSchema.selleFeedbackSchema,
    validateOnChange: false
  })

  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
    navigate('/seller/emp-bid-listing')
  }

  const errorResponse = (error) => {
    // console.log('---errorResponse--formik--errors---222:', error.response.data.errors);
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---223:', formik.errors);
  }

  const submitSellerFeedback = async (data, query = {}) => {
    try {
      // console.log('---submitSellerFeedback--data:', data)
      const formData = new FormData();
      formData.append("user_name", data['user_name']);
      formData.append("description", data['description']);
      let hasFile = document.querySelector('#file');
      if (hasFile.files[0]) {
        formData.append("file", hasFile.files[0]);
      }
      formData.append("mob_number", data['mob_number']);
      formData.append("email", data['email']);
      const response = await callApi.requestFilePOST(`/sellers-bids/seller/send-feedback`, formData, true)
      // console.log('---submitSellerFeedback---response:', response);
      // setExportFileLink('')
      successResponse(response)
    }
    catch (error) {
      // console.log('---submitSellerFeedback---error:', error);
      // setExportFileLink(`${apiEndpoints.apiHost}${error.response.data.export_file_link}`)
      errorResponse(error)
    }
  }


  return (
    <div>
      <Grid container direction="row" alignItems="center" justifyContent="" >

        <Box component="form" className="tw-mb-20" onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField id="userNameId" className="tw-w-full" label="Your Name" type="text" name="user_name" variant="outlined" onChange={formik.handleChange} value={formik.values.user_name} error={formik.errors.user_name ? true : false} helperText={formik.errors.user_name} required />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField id="descriptionId" multiline={true} rows={3} className="tw-w-full" label="Description" type="text" name="description" variant="outlined" onChange={formik.handleChange} value={formik.values.description} error={formik.errors.description ? true : false} helperText={formik.errors.description} required />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField id="file" className="tw-w-full" xs={12} sm={6} type="file" name="file" onChange={formik.handleChange} value={formik.values.file} error={formik.errors.file ? true : false} helperText={formik.errors.file} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField id="mobNumberId" className="tw-w-full" label="Mobile Number" type="text" name="mob_number" variant="outlined" onChange={formik.handleChange} value={formik.values.mob_number} error={formik.errors.mob_number ? true : false} helperText={formik.errors.mob_number} required />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField id="emailId" className="tw-w-full" label="Email" type="email" name="email" variant="outlined" onChange={formik.handleChange} value={formik.values.email} error={formik.errors.email ? true : false} helperText={formik.errors.email} />
            </Grid>

          </Grid>

          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} className="tw-mt-10">
              <Button type="submit" variant="contained">Submit</Button>
            </Grid>
          </Grid>
        </Box>

      </Grid>

      <Snackbar />
    </div>
  );

}


export { SellerFeedbackForm };
